import React, { useState } from 'react';
import Axios from 'axios';
import Swal from 'sweetalert2';

const Newsletter = () => {

    const url = "https://auraairline.com/aura_airlines/CustomerSuscribeDetails"

    const [data, setData] = useState({
        cus_name_subscriber: '',
        email_subscriber: ''
    });

    function submit(e){
        
        e.preventDefault();

        Axios.post(url,{
            cus_name_subscriber:data.cus_name_subscriber,
            email_subscriber:data.email_subscriber
        })
            .then(res=>{
                const responseData = res.data;
                console.log(responseData);

                if (responseData.status === 'SUCCESS') {
                    Swal.fire({
                        title: 'Success',
                        text: 'Thank you for getting in touch! We appreciate you subscribed us.',
                    }).then(() => {
                        // Reset the form
                        setData({
                            cus_name_subscriber:"",
                            email_subscriber:""
                        });
                    });
                    
                } else {
                    // Handle other response statuses or errors
                    Swal.fire({
                        title: 'Error',
                        text: 'Oops! Somthing went wrong. Please try again.',
                    });
                }

            })
            .catch(error => {
                console.error("An error occurred:", error);
                Swal.fire({
                    title: 'Error',
                    text: 'An error occurred while processing your request. Please try again later.',
                });
            });
                
        setData({
            cus_name_subscriber:"",
            email_subscriber:""
          });

    }

    function handle(e){
        const newdata={...data}
        newdata[e.target.id] = e.target.value
        setData(newdata)
        /*console.log(newdata)*/

    }

    return (
        <>
            <div class="container-fluid bg-secondary subscribe_section wow fadeInUp" data-wow-delay="0.1s">
                <div class="row justify-content-md-center px-xl-5">
                    <div class="col-md-6 col-12 py-5">
                        <div class="section_title_div text-center position-relative pb-3 mb-5 mx-auto" style={{ minwidth: '600px' }}>
                            <h5 class="fw-bold text-primary text-uppercase">Sign Up to Our Newsletter</h5>
                            <h1 class="mb-0" style={{ color: '#fff' }}>We Respect Your Privacy and it's Our Priority</h1>
                        </div>

                        <form id="contactForm" onSubmit={(e)=> submit(e)}>
                            <div class="input-group wow fadeInLeft" data-wow-delay="0.1s">
                                <input type="text" class="form-control border-white p-4" onChange={(e)=>handle(e)} id="cus_name_subscriber" value={data.cus_name_subscriber} placeholder="Your Name" style={{ height: '55px' }} />
                            </div><br />
                            <div class="input-group wow fadeInRight" data-wow-delay="0.1s">
                                <input type="text" class="form-control border-white p-4" onChange={(e)=>handle(e)} id="email_subscriber" value={data.email_subscriber} style={{ textTransform: 'lowercase', height: '55px' }} placeholder="Email Address" />
                                <div class="input-group-append">
                                    <button class="btn btn-primary px-4" id="subBtn" value="S E N D  M E S S A G E" type="submit" style={{ height: '55px' }}    >Subscribe</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Newsletter